"use strict";

exports.__esModule = true;
exports.transformParser = exports.transform = void 0;

var _core = require("../core");

var config = {
  transform: true,
  transformOrigin: true
};
var transform = (0, _core.system)(config);
exports.transform = transform;
var transformParser = (0, _core.createParser)(config);
exports.transformParser = transformParser;
//# sourceMappingURL=transform.js.map